var map = require('./map'),
    indexOf = require('./indexOf');

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (item) {
        return indexOf(item, this);
    };
}

if (!Array.prototype.map) {
    Array.prototype.map = function (iterator) {
        return map(iterator, this);
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/array/index.js
 ** module id = 14
 ** module chunks = 0
 **/